"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildBigCollabChannel = exports.BigCollabChannel = void 0;
var util_1 = require("../../util");
var websocket_channel_1 = require("../../websocket-channel");
var connect_status_manager_1 = require("./connect-status-manager/connect-status-manager");
var message_center_1 = require("./message-center/message-center");
var BigCollabChannel = /** @class */ (function () {
    function BigCollabChannel(options, dependency) {
        this.tag = 'BigCollabChannel';
        this.connectStatusManager = new connect_status_manager_1.ConnectStatusManager(options, dependency);
        this.messageCenter = new message_center_1.MessageCenter(options, dependency, this.connectStatusManager);
    }
    BigCollabChannel.prototype.dispose = function () {
        this.connectStatusManager.dispose();
        this.messageCenter.dispose();
    };
    BigCollabChannel.prototype.connect = function () {
        util_1.ConnectionLog.info(this.tag + " connect");
        this.connectStatusManager.connect();
    };
    BigCollabChannel.prototype.isConnected = function () {
        return this.connectStatusManager.isConnected();
    };
    BigCollabChannel.prototype.isDisconnected = function () {
        return this.connectStatusManager.isDisconnected();
    };
    BigCollabChannel.prototype.disconnect = function (reason) {
        util_1.ConnectionLog.error(this.tag + " disconnect, shutdown:" + reason.shutDown + ", errCode:" + reason.errCode + " reason:" + reason.reason);
        this.connectStatusManager.disconnect(reason);
    };
    BigCollabChannel.prototype.sendMessage = function (message) {
        var _a;
        var taskId = message.taskId, cmd = message.cmd, data = message.data;
        if (!this.connectStatusManager.isConnected()) {
            // TODO: 没有建立连接就发送，需要重新连接，需要确定大协同的状态码
            (_a = message.onError) === null || _a === void 0 ? void 0 : _a.call(message, taskId, cmd, data, {
                errCode: this.connectStatusManager.isDisconnected()
                    ? websocket_channel_1.RoomErrorCode.ROOM_SHUTDOWN : websocket_channel_1.RoomErrorCode.ROOM_STATE_ERR,
                errMsg: 'can not send message in this room state.',
            });
            return;
        }
        this.messageCenter.sendMessage(message);
    };
    BigCollabChannel.prototype.cancelSendMessageByTaskId = function (taskId) {
        var _a, _b;
        (_b = (_a = this.messageCenter).cancelSendMessageByTaskId) === null || _b === void 0 ? void 0 : _b.call(_a, taskId);
    };
    return BigCollabChannel;
}());
exports.BigCollabChannel = BigCollabChannel;
var BuildBigCollabChannel = function (options, dependency) { return new BigCollabChannel(options, dependency); };
exports.BuildBigCollabChannel = BuildBigCollabChannel;
